import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../assets/images/facebook-icon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/instagram-icon.svg";
import Terms from "../../assets/legal/terms_of_use.pdf";
import { redirect_to, hardcoded_event, rights, homepage_link, logo} from "./../../constants";

const Footer = () => {
    return (
      <footer className="footer">
        <div className="footer__container">
          <p className="footer__text">
            ©{new Date().getFullYear()}  {rights}
          </p>          
          {/*}
          <ul className="footer__links">
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
          */}
        </div>
      </footer>
    );
  };
  
  export default Footer;